import { getSupportArticleUrl } from '@/services/supportUrlService';
angular.module('leanlaw').directive('llSupport', ['$compile', function ($compile) {
  return {
    restrict: 'A',
    replace: true,
    scope: {
      llSupport: '@'
    },
    link: function (scope, element, attrs) {
      scope.placement = scope.placement || 'top';
      scope.tooltip = element.html() || "Link to Support";

      // Render the HubSpot support URL directly.
      var buildHtml = function () {
        var url = getSupportArticleUrl(scope.llSupport);
        return "<a style='color: #555' href='" + url + "' target='_blank' rel='noopener noreferrer'><span class='fa fa-question-circle ll-info' uib-popover-html='tooltip' popover-placement='top' popover-trigger='mouseenter'></span></a>";
      };
      element.html($compile(buildHtml())(scope));
    }
  };
}]);